export default "__VITE_ASSET__DeP6OFpA__"